module.exports = __webpack_public_path__ + "static/media/data1.14285629.png";